import { SymbolStatus } from '../models/market-data/types';

export const checkIfSymbolIsHalted = (symbolsStatusCache: SymbolStatus): boolean => (
  symbolsStatusCache && [ 'Halted', 'Suspended' ].includes(symbolsStatusCache.trade)
);
